import React from "react";
import { Paper, Box, Typography, Stack } from "@mui/material";
import { ArticleOutlined } from "@mui/icons-material";
import {
  textPrimary,
  textSecondary,
  softShadow,
  infoColor,
  color1,
  myApi,
} from "../../../constants/consts";

export default function InfoCard({ info }) {
  const { title = "-", description = "", image = "" } = info || {};

  // Görsel URL'ini düzelt
  const imgUrl = image
    ? image.startsWith("http")
      ? image
      : `${myApi}/${image.replace(/^\/+/, "")}`
    : null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        boxShadow: softShadow,
        border: "1px solid",
        borderColor: "rgba(0,0,0,0.06)",
        transition: "all 0.25s ease",
        "&:hover": {
          boxShadow: `0 10px 24px ${infoColor}22`,
          borderColor: `${infoColor}44`,
        },
      }}
    >
      {/* Üst satır: ikon + başlık */}
      <Stack direction="row" alignItems="flex-start" spacing={1.5}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 2,
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: `${infoColor}1A`,
            color: infoColor,
          }}
        >
          <ArticleOutlined sx={{ fontSize: 20 }} />
        </Box>
        <Typography
          variant="subtitle1"
          fontWeight={700}
          color={textPrimary}
          sx={{ lineHeight: 1.3, pt: 0.5 }}
        >
          {title}
        </Typography>
      </Stack>

      {/* Görsel (varsa) */}
      {imgUrl && (
        <Box
          sx={{
            mt: 2,
            borderRadius: 2,
            overflow: "hidden",
            backgroundColor: color1,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl}
            alt={title}
            onError={(e) => {
              e.currentTarget.parentElement.style.display = "none";
            }}
            sx={{
              width: "100%",
              maxHeight: 260,
              objectFit: "contain",
              display: "block",
            }}
          />
        </Box>
      )}

      {/* Açıklama */}
      <Typography
        variant="body2"
        color={textSecondary}
        sx={{
          mt: 2,
          lineHeight: 1.6,
          whiteSpace: "pre-wrap", // satır sonlarını koru
        }}
      >
        {description}
      </Typography>
    </Paper>
  );
}
